import { useEffect, useState } from 'react'
import { getClientProjectsByJobSiteV2, type ClientProjectsByJobSiteV2 } from '@/lib/api/v2/clients'

export function useClientProjectsByJobSiteV2(customerId: string | undefined) {
  const [data, setData] = useState<ClientProjectsByJobSiteV2 | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    if (!customerId) return

    let cancelled = false
    /* eslint-disable react-hooks/set-state-in-effect */
    setIsLoading(true)
    setError(null)
    /* eslint-enable react-hooks/set-state-in-effect */

    getClientProjectsByJobSiteV2(customerId)
      .then((d) => {
        if (cancelled) return
        setData(d)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setData(null)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [customerId])

  return { data, isLoading, error }
}
